import React, { useState } from 'react';

import { IVideoWith5050TextFields } from '../../../types/contentful';

import { trackWithFingerprint } from '../../utils/trackWithFingerprint';

import { Text } from '../Text';
import { Box } from '../Box';
import RichText from '../RichText';
import { Layout, Column, BlockContainer } from '../Layout';
import { Lightbox } from '../VideoBlock/Lightbox';

import {
  ColumnContainer,
  PlayIcon,
  TextWrapper,
  VideoButton,
  VideoWrapper
} from './styles';

export function VideoWith5050Text({
  headingText,
  bodyCopy,
  vimeoId,
  videoTitle
}: IVideoWith5050TextFields) {
  const [showingVideo, setShowingVideo] = useState(false);

  const toggleVideo = (displayVideo: boolean) => {
    setShowingVideo(displayVideo);
    if (displayVideo) {
      trackWithFingerprint('Video Opened', {
        page_url: window.location.href
      });
    } else {
      trackWithFingerprint('Video Closed', {
        page_url: window.location.href
      });
      document.getElementById('gl-video-play-button')?.focus();
    }
  };

  return (
    <BlockContainer
      marginTop={{ 0: 'l', tablet: 'blockMarginY_tablet' }}
      marginBottom={{
        0: 'blockMarginY',
        mobile: 's',
        tablet: 'blockMarginY_tablet'
      }}
      data-blockid="videoWith5050Text"
      data-testid="videoWith5050Text"
    >
      <Layout
        gutter={{ 0: 'ml', desktop: 'xl' }}
        flexWrap="wrap"
        alignItems="center"
      >
        <Column size={{ 0: 12, tablet: 6 }}>
          <VideoWrapper data-blockid="videoWrapper">
            <VideoButton
              id="gl-video-play-button"
              onClick={(e) => {
                toggleVideo(true);
                e.currentTarget.blur();
              }}
              aria-label="Play video"
              data-testid="videoWith5050Text-button"
            >
              <PlayIcon
                width="221"
                height="221"
                viewBox="0 0 221 221"
                role="img"
              >
                <path
                  className="playIconBackground"
                  d="M0 56C0 25.072 25.0721 0 56 0H164.482C195.41 0 220.482 25.0721 220.482 56V164.482C220.482 195.41 195.41 220.482 164.482 220.482H56C25.072 220.482 0 195.41 0 164.482V56Z"
                  fill="#035C67"
                />
                <path
                  className="playIconCenter"
                  d="M145.086 102.266C150.419 105.345 150.419 113.043 145.086 116.123L97.2475 143.742C91.9141 146.821 85.2474 142.972 85.2474 136.814L85.2475 81.5748C85.2475 75.4164 91.9141 71.5674 97.2475 74.6466L145.086 102.266Z"
                  fill="#80D6B0"
                />
              </PlayIcon>
            </VideoButton>
            {vimeoId && videoTitle && (
              <Lightbox
                title={videoTitle}
                showingVideo={showingVideo}
                setShowingVideo={toggleVideo}
                vimeoId={vimeoId}
              />
            )}
          </VideoWrapper>
        </Column>
        <ColumnContainer size={{ 0: 10, tablet: 5 }}>
          <TextWrapper>
            <Box marginBottom={{ 0: 'sm' }}>
              <Text
                as="h2"
                fontWeight={{ 0: 'h2' }}
                fontSize={{ 0: 'h2_0', desktop: 'h2_desktop' }}
                data-blockid="videoWith5050Text-headline"
              >
                {headingText}
              </Text>
            </Box>
            {bodyCopy && (
              <Box
                marginBottom={{ 0: 'ml' }}
                data-blockid="videoWith5050Text-subhead"
              >
                <RichText data={bodyCopy} />
              </Box>
            )}
          </TextWrapper>
        </ColumnContainer>
      </Layout>
    </BlockContainer>
  );
}
